import { datadogRum } from '@datadog/browser-rum';
import { Environment } from '@ph-env/model/environment.model';
import { Env } from '@ph-core/enums/environment';

const DATADOG_RUM_STATIC = {
  site: 'datadoghq.com',
  service: 'Phoenix-UI',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  trackResources: true,
  trackUserInteractions: true,
  trackLongTasks: true,
} as const;

export function initDatadogRum(environment: Environment): void {
  if (environment.type !== Env.UAT || !environment.datadogRum) {
    return;
  }
  try {
    datadogRum.init({
      ...DATADOG_RUM_STATIC,
      applicationId: environment.datadogRum.applicationId,
      clientToken: environment.datadogRum.clientToken,
      env: environment.type,
      version: environment.version ?? '1.0.0',
    });
  } catch (err) {
    console.warn('[Datadog] RUM init failed', err);
  }
}

/** Forwards an error to RUM only after `initDatadogRum` has succeeded. */
export function reportDatadogRumError(
  error: unknown,
  context: { feature: string; message: string; stack: string },
  extra?: Record<string, string | number>
): void {
  try {
    if (!datadogRum.getInitConfiguration()) {
      return;
    }

    datadogRum.addError(toRumError(error, context.message, context.stack), {
      feature: context.feature,
      message: context.message,
      ...extra,
    });
  } catch (err) {
    console.warn('[Datadog] RUM error report failed', err);
  }
}

function toRumError(error: unknown, message: string, stack: string): Error {
  if (error instanceof Error) {
    return error;
  }

  const reportable = new Error(message);
  if (stack) {
    reportable.stack = stack;
  }
  return reportable;
}
